export default {"src":"/org/_next/static/media/success.05fe0f2b.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};